import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Field, reduxForm, Form, change} from 'redux-form'
import ValidatedCustomInput from "views/Components/ValidatedCustomInput.jsx"
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import withStyles from "@material-ui/core/styles/withStyles";
import styles from "assets/jss/material-dashboard-pro-react/views/form";

import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
// core components
import Button from "components/CustomButtons/Button.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

// icons
import PlaylistAddRounded from "@material-ui/icons/PlaylistAddRounded";
import Notes from "@material-ui/icons/Notes";

import {required} from 'views/utils/validations'

import {
  adjustmentReasonsSave
} from 'actions/adjustmentsReasons'


import {
  danger,
  success,
} from 'actions/notification'



const validate = values => {

 const errors = {}

 const requiredFields = [

 'amount',

 ]

 requiredFields.forEach(field => {

 if (!values[field]) {

 errors[field] = 'Required'

 }

 })

 

 return errors

}



class CreateEdit extends Component {
   constructor(props) {
    super(props);
    this.state = {
      maxAmount: 0,
      selectedIb: {},
      usdAmount: 0,
      }
    }


    componentWillMount(){
    }
		componentDidMount(){
      
    }
		getInput(data) {
      return <Field
              name={data.key}
              placeholder={data.name}
              id={data.key}
              icon={data.icon}
              type={data.type}
              props={{
                name: data.key
              }}
              validate={data.validate ? data.validate : []}
              component={ValidatedCustomInput}
            />
    }
    getInputNumber(data) {
			return <Field
							name={data.key}
							placeholder={data.name}
							id={data.key}
              icon={data.icon}
              type="number"
							props={{
								name: data.key
							}}
							validate={data.validate ? data.validate : []}
              component={ValidatedCustomInput}
              max={0}
              min={0}
						/>
		}
		
    submit(values){
      
      values.adjustmentReasonId = 0;
      
			this.props.save(values)
				.then(e=>{
					this.props.success(e.adjustmentReasonId + ' Added',4)
					//this.props.fetchAll()
					this.props.history.goBack()
				})
				.catch(e=>{this.props.danger(e+'',4);})
    }

    
    handleChange = name => event => {
      this.setState({ [name]: event.target.value });
    };

    render(){
    const {classes, handleSubmit} = this.props
    
    return(
      <GridContainer justify="center">
        <GridItem xs={12} sm={8}>
          <Card>
            <CardBody>
              <Form onSubmit={handleSubmit(this.submit.bind(this))}>
                <GridContainer justify="center">

                  <GridItem xs={12} sm={12}>
                    <h4 className={classes.infoText}>
                      Adjustment Reason
                    </h4>
                  </GridItem>
                  
                    <GridItem style={{marginTop:"25px"}} xs={12} sm={12} md={12} lg={10}>
                    <InputLabel className={classes.label}>Reason</InputLabel>
                      <br />
                      <FormControl fullWidth>
                    <Field
                      name="name"
                      placeholder=""
                      id="Name"
                      props={{
                        name:"Name"
                      }}
                      icon={<PlaylistAddRounded className={this.props.classes.inputAdornmentIcon}/>}
                      validate={[required]}
                      component={ValidatedCustomInput}
                    />
                    </FormControl>
                    </GridItem>
                    <GridItem style={{marginTop:"25px"}} xs={12} sm={12} md={12} lg={10}>
                    <InputLabel className={classes.label}>Description</InputLabel>
                      <br />
                      <FormControl fullWidth>
                        <Field
                          name="description"
                          placeholder=""
                          id="description"
                          props={{
                            name:"description"
                          }}
                          icon={<Notes className={this.props.classes.inputAdornmentIcon}/>}
                          validate={[required]}
                          component={ValidatedCustomInput}
                        />
                      </FormControl>
                    </GridItem>
                    <GridItem style={{marginTop:"25px"}} xs={12} sm={12} md={12} lg={10}>
                    </GridItem>
                    <GridItem style={{marginTop:"25px"}} xs={12} sm={12} md={1} lg={1}><br/></GridItem>
                    
                    <GridItem style={{marginTop:"25px"}} xs={12} sm={12} md={6} lg={6}>
                   
                   
                    </GridItem>
                   

                  <GridItem xs={12} sm={12} md={12} lg={10}>
                      
                      <Button type="submit"  className={classes.submit} color="success">Submit</Button>
                      <Button type="cancel"  className={classes.submit} color="danger">Cancel</Button>
                  </GridItem>
                </GridContainer>
              </Form>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
      )
  }
}

function mapStateToProps(state) {
  return {
    adjustmentsReasons: state.adjustmentsReasons,
    adjustmentReasons: state.adjustmentsReasons.listAll,
    
	}
}

function mapDispatchToProps(dispatch) {
	return {
		save:(data)=>dispatch(adjustmentReasonsSave(data)),
		danger:(text,sec)=>dispatch(danger(text,sec)),
		success:(text,sec)=>dispatch(success(text,sec)),
    change: (field, value) => dispatch(change('createCreateEditForm', field, value)),
	}
}

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(reduxForm({ form: 'createCreateEditForm', validate })(CreateEdit)))



// WEBPACK FOOTER //
// ./src/views/AdjustmentsReason/CreateEdit.jsx